// extracted by mini-css-extract-plugin
export default {"movieCard":"MainCard_movieCard__E3dnD","movieCard_voteAverage":"MainCard_movieCard_voteAverage__Fvcq8","movieCard_description":"MainCard_movieCard_description__h7bfr"};